import api from './axios';

// ============== Cadastro Pro ANTES de criar usuario ==============

export async function initPro({ nome, email, password }) {
  const { data } = await api.post('/subscription/init-pro', { nome, email, password });
  return data; // { subscriptionId, customerId, clientSecret }
}

export async function finalizePro({ subscriptionId, customerId, nome, email, password }) {
  const { data } = await api.post('/subscription/finalize-pro', {
    subscriptionId,
    customerId,
    nome,
    email,
    password,
  });
  return data; // { user, token }
}

export async function abortPending({ subscriptionId, customerId }) {
  const { data } = await api.post('/subscription/abort-pending', { subscriptionId, customerId });
  return data; // { ok: true }
}

// ============== Upgrade de user existente Free → Pro (autenticado) ==============

export async function createSubscriptionIntent() {
  const { data } = await api.post('/subscription/create-intent');
  return data; // { subscriptionId, clientSecret, status }
}

export async function finalizeUpgrade(subscriptionId) {
  const { data } = await api.post('/subscription/finalize-upgrade', { subscriptionId });
  return data; // { plano, planId, planStatus, planCancelAt }
}

export async function cancelIncompleteSubscription() {
  const { data } = await api.post('/subscription/cancel-incomplete');
  return data; // { ok: true }
}

export async function cancelSubscription() {
  const { data } = await api.post('/subscription/cancel');
  return data; // { planCancelAt }
}
